import { createContext, useContext, useState, useCallback } from "react";

const DemoContext = createContext(null);
export const useDemo = () => useContext(DemoContext);

export function DemoProvider({ children }) {
  const [showDemo, setShowDemoState] = useState(() => {
    const v = localStorage.getItem("oe_show_demo");
    return v === null ? true : v === "1";
  });
  const setShowDemo = useCallback((val) => {
    setShowDemoState(val);
    localStorage.setItem("oe_show_demo", val ? "1" : "0");
  }, []);
  return (
    <DemoContext.Provider value={{ showDemo, setShowDemo }}>
      {children}
    </DemoContext.Provider>
  );
}
